import { getSquad } from '$utils/data';
import getTeams from '$utils/getTeams';

/**
 * Loads the data for a specific team.
 *
 * @param {object} options - The options for loading the data.
 * @param {function} options.fetch - The fetch function used to make API requests.
 * @param {object} options.params - The parameters for the team.
 * @returns {Promise<object>} A promise that resolves to an object containing the loaded data, team, and teams.
 */
export async function load({ fetch, params, parent }) {
  const { data } = await parent();

  const teams = getTeams(data.matches);

  const team = teams.getTeam(params.slug);

  const squad = await getSquad({ fetch, team });

  return {
    data,
    team,
    teams,
    squad,
  };
}
